import React, { useEffect, useState } from 'react';
import LocationPointer from '../images/location-pointer.svg';
import { Link } from 'react-router-dom';
import NotifyImage from '../images/notification_icon.png';

import { useUnreadCount } from './UnreadCountContext';

type Props = {
  location: any;
  handlePlaceChanged(place): void;
  handleClose(): void;
};

const FindLocationHome: React.FC<Props> = (props) => {
  const [error, setError] = useState('');
  const [location, setLocation] = useState({ lat: 0, lng: 0, name: '' });
  const [showLocation, setShowLocation] = useState(true);

  // Unread counts from context
  const { notificationUnread, setNotificationUnread } = useUnreadCount();

  const newLocation = async (place, name) => {
    var obj = {
      name: name,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    setLocation(obj);
    setError('');
    //console.log(obj);
    setShowLocation(false);
    props.handlePlaceChanged(obj);
  };

  const handlePlaceChange = (place) => {
    if (place.geometry && place.address_components) {
      const addressComponents = place.address_components;
      let fullName: String = '';

      const country = addressComponents
        .filter((component) => component['types'].includes('country'))
        .map((component) => {
          return component;
        });

      const state = addressComponents
        .filter((component) => component['types'].includes('administrative_area_level_1'))
        .map((component) => {
          return component;
        });

      const locality = addressComponents
        .filter((component) => component['types'].includes('locality'))
        .map((component) => {
          return component;
        });

      if (locality.length > 0) {
        fullName = `${locality[0].long_name}, ${state[0].short_name}, ${country[0].short_name}`;
        newLocation(place, fullName);
        return;
      }

      const administrativeArea = addressComponents
        .filter((component) => component['types'].includes('administrative_area_level_2'))
        .map((component) => {
          return component;
        });

      if (administrativeArea.length > 0) {
        fullName = `${administrativeArea[0].long_name}, ${state[0].short_name}, ${country[0].short_name}`;
        newLocation(place, fullName);
        return;
      }
    }
    setLocation({ lat: 0, lng: 0, name: '' });
    setError('Not Found!');
  };

  const handleNotifyIconClick = async () => {
    try {
      const stored = localStorage.getItem('YoloMeal');
      if (!stored) return;

      const user = JSON.parse(stored);
      if (!user?.token) return;

      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/notify/mark-read-all`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });

      if (!res.ok) {
        console.error('Failed to mark notifications as read');
        return;
      }

      setNotificationUnread(0);
    } catch (err) {
      console.error('Error marking notifications as read', err);
    }
  };

  useEffect(() => {
    const center = { lat: props.location.lat, lng: props.location.lng };

    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };

    const input = document.getElementById('restaurant-name') as HTMLInputElement;

    const options = {
      bounds: defaultBounds,
      fields: ['address_components', 'geometry'],
      origin: center,
      strictBounds: false,
      types: ['geocode'],
    };

    const autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      handlePlaceChange(place);
    });
  }, []);

  return (
    <div className="container" style={{ paddingTop: '0' }}>
      <section>
        <div className="d-flex align-items-centers">
          <div className="location-input-wrapper">
            <input
              id="restaurant-name"
              className="field xl-filed location-input restaurant-input mt-4 mb-4"
              placeholder={props.location.name ? props.location.name : 'Enter your desired city.'}
              style={{ paddingRight: '45px', marginBottom: '1px', marginTop: '50px' }}
            />
            <img src={LocationPointer} alt="Location Icon" width={40} height={40} className="home-location-icon" />
          </div>
          <div
            className="header-icons"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '0px',
              marginLeft: '20px',
              marginTop: '-25px',
            }}
          >
            <Link
              to="/notify"
              style={{
                display: 'inline-block',
                cursor: 'pointer',
              }}
              onClick={handleNotifyIconClick}
            >
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img src={NotifyImage} alt="notifications" style={{ width: 75, marginTop: 14, marginRight: 70 }} />

                {notificationUnread > 0 &&
                  (notificationUnread > 9 ? (
                    <span
                      style={{
                        position: 'absolute',
                        top: 8,
                        right: 67,
                        background: 'red',
                        color: 'white',
                        borderRadius: '50px',
                        padding: '7px 5px',
                        fontSize: 13,
                        fontWeight: 'bold',
                        lineHeight: '1',
                        minWidth: 18,
                        textAlign: 'center',
                        pointerEvents: 'none',
                      }}
                    >
                      9+
                    </span>
                  ) : (
                    <span
                      style={{
                        position: 'absolute',
                        top: 9,
                        right: 76,
                        background: 'red',
                        color: 'white',
                        borderRadius: '50%',
                        padding: '3.5px 7px',
                        fontSize: 13,
                        fontWeight: 'bold',
                        lineHeight: '1',
                        minWidth: 18,
                        textAlign: 'center',
                        pointerEvents: 'none',
                      }}
                    >
                      {notificationUnread}
                    </span>
                  ))}
              </div>
            </Link>
          </div>
        </div>
        {error !== '' && <h2 className="futuralt-book text-center">{error}</h2>}
        {location.name !== '' && showLocation && <h2 className="futuralt-book text-center">{location.name}</h2>}
      </section>
    </div>
  );
};
export default FindLocationHome;
